import PropTypes from "prop-types";
import React from "react";
import {
  FormField,
  SensitiveFormField,
  getMaxLengthRule,
} from "./EndpointFormUtils";

export default function StaticHeaderTokenForm(props) {
  const { control, errors, sensitiveFieldProps } = props;

  return (
    <>
      <FormField
        name="scheme"
        label="Scheme"
        description="The value representing the token type that will be sent in the header as '<headerName>: <scheme> <token>'"
        rules={getMaxLengthRule(60)}
        control={control}
        errors={errors}
      />
      <FormField
        name="headerName"
        label="Header Name"
        description="The header name sent with every request."
        rules={getMaxLengthRule(60)}
        control={control}
        errors={errors}
      />
      <SensitiveFormField
        name="value"
        label="Token"
        description="The token sent in the header for every request. Your system can use this to verify the request is coming from Stel"
        rules={getMaxLengthRule(4000)}
        control={control}
        errors={errors}
        {...sensitiveFieldProps}
      />
    </>
  );
}

StaticHeaderTokenForm.propTypes = {
  control: PropTypes.shape().isRequired,
  errors: PropTypes.shape().isRequired,
  sensitiveFieldProps: PropTypes.shape({
    showExistingTokenMessage: PropTypes.bool,
    validateToken: PropTypes.bool,
  }),
};

StaticHeaderTokenForm.defaultProps = {
  sensitiveFieldProps: {
    showExistingTokenMessage: false,
    validateToken: true,
  },
};
